import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Routes from '../../routes';
import {
  preselectTypeAndResource,
} from '../store/actions';

import { resourceTypes } from '../provisionQualitySinglePage/provisionQualitySingle.constants';
import { SPECIAL_TYPE_TOGGLE_MORE } from '../constants';

class ProvisionQualitySingleLinkRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired,
    data: PropTypes.oneOfType([
      PropTypes.shape({
        businessDescription: PropTypes.string.isRequired,
      }).isRequired,
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
      }).isRequired,
    ]),
    preselectTypeAndResource: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  navigateToProvisionQualitySinglePage = () => {
    const {
      preselectTypeAndResource,
      value,
      history,
    } = this.props;

    preselectTypeAndResource(value, resourceTypes.business);
    history.push(Routes.dashboard.PROVISION_QUALITY_SINGLE);
  };

  render() {
    const { data, value } = this.props;

    if (data.type === SPECIAL_TYPE_TOGGLE_MORE) {
      return (
        <button
          className="widget-link-renderer btn btn-link"
          onClick={(data.onClick)}
          type="button"
        >
          {value}
        </button>
      );
    }

    return (
      <button className="widget-link-renderer btn btn-link" onClick={this.navigateToProvisionQualitySinglePage}>
        {data.businessDescription}
      </button>
    );
  }
}

export default connect(
  null,
  {
    preselectTypeAndResource,
  }
)(withRouter(ProvisionQualitySingleLinkRenderer));
